import { Api } from "api";
import { DocumentFilters } from "types/document";
import { FileDetails } from "types/file";

export const getDocuments = async (payload: DocumentFilters) => {
  const hash = localStorage.getItem("hash");
  const statusQuery = payload.status ? [+payload.status] : undefined;
  const payload_hash = {
    ...payload,
    status: statusQuery,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_document_approval_requests/`, payload_hash);
  return res.data;
};

export const getDocumentsTable = async (payload: DocumentFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_document_approval_requests_table/`, payload_hash);
  return res.data;
};

export const getDocumentsTableList = async (payload: DocumentFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/api/v1/document_requests/utils/table_list/`, payload_hash);
  return res.data;
};

export const exportDocumentsToExcel = async (payload?: DocumentFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const search = payload?.search ? `?search=${payload.search}` : "";
  const url = `/api/v1/document_requests/utils/table_list/download_excel/${search}`;
  const res = await Api.post(url, payload_hash, { responseType: "blob" });
  return res.data;
};

export const getDocumentById = async (documentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(
    `/get_document_approval_requests_by_id/?hash_pw=${hash}&document_request_id=${documentId}`
  );
  return res.data;
};

export const createDocumentRequest = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/create_document_approval_request/?hash_pw=${hash}`, payload);
  return res.data;
};

export const approveDocumentRequest = async (documentId: number, approved: boolean) => {
  const hash = localStorage.getItem("hash");
  const url = `/approve_document_request/?hash_pw=${hash}&document_request_id=${documentId}&approval=${approved}`;
  const res = await Api.post(url);
  return res.data;
};

export const restartDocumentRequest = async (documentId: number) => {
  const hash = localStorage.getItem("hash");
  const url = `/api/v1/document_requests/${documentId}/restart/?hash_pw=${hash}`;
  const res = await Api.post(url, {});
  return res.data;
};

export const deleteDocument = async (documentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/delete_document_approval_request/${documentId}?hash_pw=${hash}`);
  return res.data;
};

export const uploadDocumentFiles = async (document_request_id: number, payload: FormData) => {
  const hash = localStorage.getItem("hash");
  payload.append("hash_pw", hash || "");
  const res = await Api.post(`/upload_document_files/${document_request_id}`, payload);
  return res.data;
};

export const getDocumentFileNames = async (documentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_document_file_names/${documentId}?hash_pw=${hash}`);
  return res.data;
};

export const getDocumentFileLink = async (documentId: number, file: FileDetails) => {
  const hash = localStorage.getItem("hash");
  const payload = {
    ...file,
    hash_pw: hash,
  };
  const url = `download_document_file/${documentId}?hash_pw=${hash}`;
  const res = await Api.post(url, payload, { responseType: "blob" });
  return res;
};

export const getDocumentHtmlPreview = async (documentId: number, fileName: string) => {
  const hash = localStorage.getItem("hash");
  const url = `/document_requests/${documentId}/utils/attachments/html_preview/?hash_pw=${hash}&file_name=${fileName}`;
  const res = await Api.get(url);
  return res.data;
};

export const getDocumentApprovals = async (request_id: number) => {
  const hash = localStorage.getItem("hash");
  const url = `/get_documents_approvals_with_positions/?hash_pw=${hash}&document_request_id=${request_id}`;
  const res = await Api.get(url);
  return res.data;
};

export const getCommentsForDocument = async (documentId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_document_comments_by_id/?hash_pw=${hash}&document_request_id=${documentId}`);
  return res.data;
};

export const addCommentToDocument = async (documentId: number, logs: string) => {
  const hash = localStorage.getItem("hash");
  const url = `/add_comment_to_document_request/?hash_pw=${hash}&document_request_id=${documentId}&logs=${logs}`;
  const res = await Api.post(url);
  return res.data;
};

export const markDocumentTodoItemAsChecked = async (todoItemId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.patch(`/document_request_todo_items/${todoItemId}/check/?hash_pw=${hash}`);
  return res.data;
};

export const markDocumentTodoItemAsUnchecked = async (todoItemId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.patch(`/document_request_todo_items/${todoItemId}/uncheck/?hash_pw=${hash}`);
  return res.data;
};

export const previewDocumentDocFile = async (documentId: number, fileName: string) => {
  const hash = localStorage.getItem("hash");
  const url = `/document_requests/${documentId}/utils/attachments/preview/?hash_pw=${hash}&file_name=${fileName}`;
  const res = await Api.get(url, { responseType: "blob" });
  return res;
};
